// extracted by mini-css-extract-plugin
module.exports = {"warning":"styles_warning__39M7e"};